import { ApiService } from './api.service';
import { LocaleService } from './storage.service';

const PrintService = {
    getBillPDFAsBase64: async function({ accountId, billId, year, month, recaptchaToken }) {
        let requestData = {
            method: 'get',
            url: `getBillPDFAsBase64`,
            params: {
                accountId: accountId,
                bills: billId,
                year: year,
                month: month,
                recaptchaToken: recaptchaToken
            }
        };
        try {
            let response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getBillPDF: async function({ accountId, billId, year, month, recaptchaToken }) {
        let requestData = {
            method: 'get',
            url: `getBillPDF`,
            params: {
                accountId: accountId,
                bills: billId,
                year: year,
                month: month,
                recaptchaToken: recaptchaToken
            },
            responseType: 'blob'
        };
        try {
            let response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getAccountInfo: async function({ accountId, recaptchaToken }) {
        let requestData = {
            method: 'get',
            url: `/getAccountInfo`,
            params: {
                accountId: accountId,
                locale: LocaleService.getLocale(),
                recaptchaToken: recaptchaToken
            }
        };
        try {
            let response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getAccountId: async function({ accountFId, lastPaymentAmount, recaptchaToken }) {
        let requestData = {
            method: 'get',
            url: `/getAccountId`,
            params: {
                accountFId: accountFId,
                lastPaymentAmount: lastPaymentAmount,
                recaptchaToken: recaptchaToken
            }
        };

        try {
            let response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    checkLastPayment: async function({ accountFId, lastPaymentAmount, recaptchaToken }) {
        const requestData = {
            method: 'get',
            url: '/checkLastPayment',
            params: {
                accountFId,
                lastPaymentAmount,
                recaptchaToken
            }
        };

        const response = await ApiService.customRequest(requestData);

        return response.data;
    },
    searchAddress: async function({ addressText, recaptchaToken }) {
        let requestData = {
            method: 'get',
            url: `/searchAddress`,
            params: {
                addressText: addressText,
                locale: LocaleService.getLocale(),
                recaptchaToken: recaptchaToken
            }
        };
        try {
            let response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default PrintService;

export { PrintService };
